import { Cookies } from 'react-cookie';
import { getAuthUser, getCookie } from '../utils/index';
import * as types from './ActionTypes';

const cookies = new Cookies();

export const setAuthUser = authUser => dispatch => {
  cookies.set('currentUser', authUser, {
    path: '/',
    domain: '.parkhub.com'
  });
  dispatch({ type: types.AUTH_USER_SET, authUser });
};

function checkForEnvMatch() {
  return getAuthUser().ne === process.env.REACT_APP_ENV_TAG;
}

function authorizationCheck(authCookie) {
  return getAuthUser(authCookie).g.filter(rel => rel.r === 'GLOBAL_ADMIN').length > 0;
}

export const checkAuth = () => {
  const authCookie = getCookie('86553b39');
  if (authCookie && checkForEnvMatch(authCookie) && authorizationCheck(authCookie)) {
    return true;
  } else {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/actions/authUser.action.js